export const AsyncProcessStatusEnum = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  COMPLETED_WITH_ERRORS: "COMPLETED_WITH_ERRORS",
  FAILED: "FAILED",
} as const;

export type AsyncProcessStatus =
  (typeof AsyncProcessStatusEnum)[keyof typeof AsyncProcessStatusEnum];

export const AsyncProcessTypeEnum = {
  USER_UPLOAD: "USER_UPLOAD",
  CERTIFICATE_REFRESH: "CERTIFICATE_REFRESH",
} as const;

export type AsyncProcessType =
  (typeof AsyncProcessTypeEnum)[keyof typeof AsyncProcessTypeEnum];

export interface AsyncProcessProgress {
  totalRecords: number;
  processedRecords: number;
  errorRecords: number;
}

export interface AsyncProcess {
  processUuid: string;
  processType: AsyncProcessType;
  status: AsyncProcessStatus;
  progress: AsyncProcessProgress;
  startedAt: string;
  completedAt: string | null;
}

export interface AsyncProcessListResponse {
  content: AsyncProcess[];
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

export interface AsyncProcessDiscard {
  recordIdentifier: string;
  errorCode: string;
  errorMessage: string;
}

export interface AsyncProcessDetailResponse extends AsyncProcess {
  discards?: AsyncProcessDiscard[];
}
